import './close-details-automatically.js';
import './hero-swiper.js';
import './linkedin-wall.js';
import { detect } from 'detect-browser';

((Drupal, $) => {

  // Fix the context button when inside the button paragraph.
  Drupal.behaviors.ParagraphLinkButtonBehavior = {
    attach(context) {

      $('a.paragraph--type--button').on('click', 'button', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    },

  };

  // Make the image in the prefooter block the background image.
  Drupal.behaviors.preFooter = {
    attach(context) {
      document.querySelectorAll('.block-gopa-blocks-prefooter').forEach((prefooter_cta) => {
        let image = prefooter_cta.querySelector('img');

        if (!image) {
          return;
        }

        prefooter_cta.style.backgroundImage = `url('${image.src}')`;
        image.remove();
      });
    },
  };

  // Change the appearance of the Shariff Social Sharing block.
  Drupal.behaviors.ShariffBehavior = {
    attach(context) {
      window.addEventListener('load', () => {
        once('shariff-behavior', '.shariff', context).forEach(modifyShariffButtons);
      });
    },
  };

  function modifyShariffButtons(shariff) {
    const ul = shariff.querySelector('ul');
    if (!ul) {
      return;
    }

    // Add "Share on" text at the beginning
    ul.insertAdjacentHTML('afterbegin', `<li class="shariff-text">${Drupal.t('Share on')}</li>`);

    // Process buttons
    shariff.querySelectorAll('.shariff-button').forEach(button => {
      const link = button.querySelector('a');
      if (!link) {
        return;
      }

      link.innerHTML = ''; // Clear content
      link.classList.add('btn', 'btn-icon', 'btn-fill'); // Add classes

      const platformClass = [...button.classList].find(cls => cls !== 'shariff-button');
      if (platformClass) {
        const icon = document.createElement('i');
        icon.className = `i-${platformClass}`; // Generate icon class
                                               // dynamically
        link.appendChild(icon); // Append icon
      }
    });
  }

  // Animates counter numbers from 0 to their value when they enter the
  // viewport.
  Drupal.behaviors.counterCountUp = {
    attach: function (context, settings) {
      // Select each .counter-number element once to avoid duplicate processing.
      var counters = once('counterCountUp', '.counter-number', context);
      if (!counters.length) {
        return;
      }
      var $counters = $(counters);

      // Check if counters are in view and animate them.
      function animateCounters() {
        $counters.each(function () {
          var $this = $(this);
          // Skip already animated counters.
          if ($this.data('counted')) {
            return;
          }
          // If the counter is visible...
          var elemTop = $this.offset().top;
          var windowBottom = $(window).scrollTop() + $(window).height();
          if (windowBottom > elemTop) {
            // Parse the numeric value and mark as animated.
            var finalVal = parseInt($this.text().replace(/[^0-9]/g, ''), 10);
            $this.data('counted', true);
            $this.text('0');
            // Animate from 0 to finalVal (adjust duration to change speed).
            $({ count: 0 }).animate({ count: finalVal }, {
              duration: 2000, // adjust speed here
              easing: 'swing',
              step: function (now) {
                $this.text(Math.floor(now));
              },
              complete: function () {
                $this.text(finalVal);
              },
            });
          }
        });
      }

      // Check counters on page load and when scrolling.
      animateCounters();
      $(window).on('scroll.counterCountUp', animateCounters);
    },
  };
})(Drupal, jQuery);

let browser_detect = () => {

  const browser = detect();

  // Handle the case where we don't detect the browser.
  if (browser) {
    document.body.classList.add(`browser-${browser.name}`);
  }
};
window.addEventListener('load', browser_detect);
